import PageMap from "@/router/PageMap";
import ParamMap from "@/router/ParamMap";

export default {
    data() {
        return {
            pagemap: PageMap,
            parammap: ParamMap,
        };
    },

    methods: {
        backToOld() {
            this.getRoute({ page: this.$route.name, params: this.$route.params, guiver: 'old', travel: true });
        },

        transformToOldGuiRoute({ name, params }) {
            const baseurl = (process.env.NODE_ENV != 'production') ? 'https://test1.qwips.net' : window.location.origin;
            const oldsitepathname = "/ServiceProviderWebSite/" + "Views/";
            const subpage = name;
            const oldsubpage = this.pagemap.get(subpage);

            let oldpagequery = oldsubpage?.includes("?") ? "" : "?";
            for (const key in params) {
                const value = params[key];
                const oldKey = this.parammap.get(key);
                const query = oldKey + "=" + value + "&";
                if (value && oldKey && !oldsubpage?.includes(oldKey) && !oldpagequery?.includes(oldKey)) {
                    oldpagequery = oldpagequery + query;
                }
            }
            oldpagequery = oldpagequery.substring(0, oldpagequery.length - 1);
            var calculatedurl = baseurl + oldsitepathname + oldsubpage + oldpagequery;
            /*
            const newGuiLoggable = { page: subpage, params, url: this.$router.resolve({ name: subpage, params }).href }
            const oldGuiLoggable = { page: oldsubpage, params: oldpagequery, url: calculatedurl }
            */
            return calculatedurl;
        },

        getRoute({ page, params, guiver, travel }) {
            var route;
            if (guiver && guiver.toLowerCase() === 'old') {
                route = this.transformToOldGuiRoute({ name: page, params });
                if (travel) {
                    window.location = route
                }
            }
            else {
                route = { name: page, params };
                if (travel) {
                    this.$router.push(route);
                }
                else {
                    route = this.$router.resolve(route).href;
                }
            }
            return route
        },
    },

    computed: {

    },
}